export enum ContextType {
  Organization = 'Organization',
  Community = 'Community',
}
